export const resolveBrandsFromCategoryNode = (brandIds = [], brandOptions = []) => {
  const allowedIds = new Set(brandIds)

  return brandOptions.filter((brand) => allowedIds.has(brand.id))
}

export const areSameBrandSets = (leftBrands = [], rightBrands = []) => {
  if (leftBrands.length !== rightBrands.length) {
    return false
  }

  const leftIds = new Set(leftBrands.map((brand) => brand.id))

  return rightBrands.every((brand) => leftIds.has(brand.id))
}
